/**
 * Convert a location name to a URL-safe slug.
 * "Downtown Location" → "downtown-location"
 * "123 Main St. #4"  → "123-main-st-4"
 */
export function slugifyLocationName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')  // remove special chars
    .replace(/\s+/g, '-')           // spaces → hyphens
    .replace(/-+/g, '-')            // collapse consecutive hyphens
    .replace(/^-|-$/g, '')          // trim leading/trailing hyphens
}
